export enum HighlightedBlockComponentTypeEnum {
	RIGHT_IMAGE,
	LEFT_IMAGE,
	NO_IMAGE
}
